import { createPortal } from "react-dom";
function ErrorDialog(props) {
	return createPortal(
		<div
			className='delete-article-wrapper'
			color={props.theme.color}
			fontmultiplier={props.theme.fontMultiplier}
		>
			<div className='delete-article'>
				<div>{`Ошибка: "${props.errorDialog.message}"`}</div>
				<div className='button-block'>
					<div
						className='close-button'
						onClick={() =>
							props.setErrorDialog((prev) => ({ ...prev, open: false }))
						}
					>
						Закрыть
					</div>
				</div>
			</div>
		</div>,
		document.getElementById("error")
	);
}

export default ErrorDialog;
